import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { GET_GL_MASTER_DATA } from "./apiRoutes";

const mutateAddGlMasterData = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${GET_GL_MASTER_DATA}`, data);
};

const useAddGlMasterDataMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddGlMasterData,
    ...queryParams,
  });

export default useAddGlMasterDataMutation;
